import React, { useEffect, useState } from 'react';
import classes from "./ReverseQuizPage.module.css";
import Header from '../components/Header';
import { useNavigate } from 'react-router-dom';
import BottomNavbar from '../components/BottomNavbar';
import { FaArrowLeft, FaQuestion } from "react-icons/fa6";
import * as motion from "motion/react-client"
import ReverseQuizInfoModal from '../components/ReverseQuizInfoModal';

const ReverseQuizPage = () => {
    const navigate = useNavigate();
    const [modal,setModal]=useState(false);
    const [level, setLevel] = useState(1);
    const closeModal=()=>{
        setModal(false);
    }

    useEffect(()=>{
        setModal(true);
    },[]);

    return (
        <>
            <Header hideLanguage={true} />

            <div className={`${classes.container}`}>
                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate("/home");
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>
                    <h2 className={classes.header_quiz_text}>Reverse Quiz</h2>
                </div>

                <div className={classes.quiz_image_container}>
                    <img src={"/assets/images/reverse_quiz.svg"} alt={"Reverse Quiz"} className={classes.quiz_image} />
                </div>

                <div className={classes.quiz_questions_container}>
                    <div className={classes.question_image_icon_container}>
                        <img src='/assets/images/question.png' alt={"question"} className={classes.question_image_icon} />
                    </div>
                    <p className={classes.question_text}>10 questions</p>
                </div>

                <div className={classes.quiz_description_container}>

                    <p className={classes.quiz_description_title}>
                        How to Play?
                    </p>

                    <p className={classes.quiz_description}>
                        Users will be presented with a set of options, where one option is intentionally incorrect. Users are required to choose the incorrect option.
                    </p>

                    <button type='button' className={classes.htp_btn} onClick={()=>setModal(true)}>
                        How to Play?
                    </button>
                </div>

                {/* <div className={classes.quiz_description_container}> */}

                <p className={classes.quiz_description_title}>
                    Choose Level
                </p>

                <div className={classes.levels_container}>
                    <div className={`${classes.level_container} ${level === 1 && classes.beginner_active}`}
                        onClick={() => setLevel(1)}

                    >
                        <div className={classes.level_sub_container}>
                            <div className={classes.level_info}>
                                <img src="/assets/images/Beginner.png" alt="beginner level" className={classes.level_img} />
                                <p className={classes.level_text}>Beginner</p>
                            </div>
                            <div className={`${classes.points_badge} ${classes.beginner}`}>
                                <p className={classes.points}>50 Points</p>
                            </div>
                        </div>
                    </div>

                    <div className={`${classes.level_container} ${level === 2 && classes.intermediate_active}`}
                        onClick={() => setLevel(2)}
                    >
                        <div className={classes.level_sub_container}>
                            <div className={classes.level_info}>
                                <img src="/assets/images/Intermediate.png" alt="intermediate level" className={classes.level_img} />
                                <p className={classes.level_text}>Intermediate</p>
                            </div>
                            <div className={`${classes.points_badge} ${classes.intermediate}`}>
                                <p className={classes.points}>80 Points</p>
                            </div>
                        </div>
                    </div>

                    <div className={`${classes.level_container} ${level === 3 && classes.advance_active}`}
                        onClick={() => setLevel(3)}

                    >
                        <div className={classes.level_sub_container}>
                            <div className={classes.level_info}>
                                <img src="/assets/images/Advance.png" alt="advance level" className={classes.level_img} />
                                <p className={classes.level_text}>Advance</p>
                            </div>
                            <div className={`${classes.points_badge} ${classes.advance}`}>
                                <p className={classes.points}>100 Points</p>
                            </div>
                        </div>
                    </div>

                </div>


                {/* </div> */}

                <button className={`${classes.play_button}`} type='button'
                    onClick={() => {
                        navigate("/reverse-quiz/finding-opponent", {
                            state: {
                                level: level,
                            }
                        })
                    }}
                >
                    Play
                </button>

            </div>

            <BottomNavbar active={2} />
            {modal && <ReverseQuizInfoModal closeModal={closeModal} />}
        </>
    )
}

export default ReverseQuizPage